import { atom } from 'recoil'

export interface IPlayerAtomState {
  live: boolean
  selectedTimeInternal: '1m' | '5m' | '30m' | '1h' | '12h' | '24h' | '7d' | '30d'

  offlineTsFrom: number
  offlineTsTo: number
}

const playerAtom = atom<IPlayerAtomState>({
  key: 'player',
  default: {
    live: true,
    selectedTimeInternal: '1m',

    offlineTsFrom: 0,
    offlineTsTo: 0,
  },
})
export default playerAtom
